
import React, { useRef, useState } from "react";
import { Link as RouterLink, useSearchParams, useParams, useNavigate, useLocation } from 'react-router-dom';

// material
import { styled } from '@mui/material/styles';
import {
  Box, Typography, Table,
  Grid,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  LinearProgress,
  Avatar,
  Badge,
  Paper,
  Collapse,
  IconButton,
  TableSortLabel
} from '@mui/material';

import { makeStyles } from '@mui/styles';


import "../css/GlobalStyles.css";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import PropTypes from "prop-types";

import { SoundBoxDeviceMoreMenu, TestSoundBoxPaymentModal, ActivateDeviceModal } from '../components/_dashboard/soundbox'


import { isoDateFormatInDmyhs, isoDateFToNow } from '../utils/formatTime';

// components
import Page from '../components/Page';

import { showFieldValueWithCheck, crossMarkString } from '../utils/Utilities'
import { APP_CONSTANTS } from "../URLConstants";


// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    // backgroundColor: '#44b700',
    // color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}));

const useStyles = makeStyles({
  cardWithBorder: {
    background: "#FFFFFF",
    border: " 1px solid #B0B9C7",
    boxShadow: "0px 10px 19px 1px #EAEAFF",
    boxSizing: "border-box",
    borderRadius: "20px",
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '75vh',
    maxHeight: '800px',
    marginRight: "3px",
    width: "100%",
    minWidth: "100%",
  },
  backGroundRed: {
    background: "rgba(195, 10, 10, .1)"
  },
  backGroundWhite: {
    background: 'white'
  }
});



export default function MerchantListForSupport({ audioCubeMerchantListData, createSortHandler, filterMetas, handleScroll, mref }) {


  const merchantsTableRef = useRef(null);

  const [audioCubeMerchantListDataLoading, setAudioCubeMerchantListDataLoading] = useState(false)


  const [merchantDetailsOpen, setMerchantDetailsOpen] = useState("");
  const [testSoundBoxModalMetas, setTestSoundBoxModalMetas] = useState({ open: false, data: [], selectedMerchant: {} })
  const [activateModalMetas, setActivateModalMetas] = useState({ open: false, data: [], selectedMerchant: {}, actionType: "" })


  const handleUserMoreMenuClick = (action, deviceData) => {

    switch (action) {
      case "test_payment": {
        setTestSoundBoxModalMetas({ ...testSoundBoxModalMetas, open: true, data: deviceData, selectedMerchant: deviceData }
        )
        break;
      }
      case "activate_device": {
        setActivateModalMetas({ ...testSoundBoxModalMetas, open: true, data: deviceData, selectedMerchant: deviceData, actionType: APP_CONSTANTS?.ADD_DEVICE_MERCHANT_ACTION })
        break
      }
      case "deactivate_device": {
        setActivateModalMetas({ ...testSoundBoxModalMetas, open: true, data: deviceData, selectedMerchant: deviceData, actionType: APP_CONSTANTS?.REMOVE_DEVICE_MERCHANT_ACTION })
        break
      }
      default: {
        return ""
      }
    }
  }



  const handMerchantDetailsOpenClick = (merchantId) => {
    if (merchantDetailsOpen === merchantId)
      setMerchantDetailsOpen("")
    else
      setMerchantDetailsOpen(merchantId)

  }




  return (
    <Box >

      {audioCubeMerchantListDataLoading && <LinearProgress color="success" />}

      {
        (audioCubeMerchantListData !== null && audioCubeMerchantListData !== undefined) &&
          <TableContainer data-testid='merchant-list-support-component' component={Paper} sx={{ maxHeight: 600, overflowY: 'scroll' }} ref={mref} onScroll={handleScroll}>
            <Table aria-label="collapsible merchant table" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell />
                  <TableCell sx={{ minWidth: '10vw', fontWeight: 700 }}>Merchant Id </TableCell>
                  <TableCell sx={{ minWidth: '15vw', fontWeight: 700 }} align="center">
                    <TableSortLabel
                      active={filterMetas?.orderByFiled === 'name'}
                      direction={filterMetas?.orderByFiled === 'name' ? filterMetas?.orderBy : 'ASC'}
                      onClick={createSortHandler('name')}
                      IconComponent={filterMetas?.orderBy === 'ASC' ? ArrowUpwardIcon : ArrowDownwardIcon}>
                      Merchant Name
                    </TableSortLabel>

                  </TableCell>
                  <TableCell sx={{ minWidth: '10vw', fontWeight: 700 }} align="center">Merchant Mobile</TableCell>
                  <TableCell sx={{ minWidth: '10vw', fontWeight: 700 }} align="center">Zone </TableCell>
                  <TableCell sx={{ minWidth: '10vw', fontWeight: 700 }} align="center">Status</TableCell>
                  <TableCell sx={{ minWidth: '15vw', fontWeight: 700 }} align="center">
                    <TableSortLabel
                      active={filterMetas?.orderByFiled === 'requested_date'}
                      direction={filterMetas?.orderByFiled === 'requested_date' ? filterMetas?.orderBy : 'ASC'}
                      onClick={createSortHandler('requested_date')}
                      IconComponent={filterMetas?.orderBy === 'ASC' ? ArrowUpwardIcon : ArrowDownwardIcon}>
                      Onboarded
                    </TableSortLabel>


                  </TableCell>
                  <TableCell sx={{ minWidth: '15vw', fontWeight: 700 }} align="center">
                    <TableSortLabel
                      active={filterMetas?.orderByFiled === 'active_date'}
                      direction={filterMetas?.orderByFiled === 'active_date' ? filterMetas?.orderBy : 'ASC'}
                      onClick={createSortHandler('active_date')}
                      IconComponent={filterMetas?.orderBy === 'ASC' ? ArrowUpwardIcon : ArrowDownwardIcon}>
                      Installation Date
                    </TableSortLabel>

                  </TableCell>
                  <TableCell sx={{ minWidth: '15vw', fontWeight: 700 }} align="center">
                    <TableSortLabel
                      active={filterMetas?.orderByFiled === 'last_activity_date'}
                      direction={filterMetas?.orderByFiled === 'last_activity_date' ? filterMetas?.orderBy : 'ASC'}
                      onClick={createSortHandler('last_activity_date')}
                      IconComponent={filterMetas?.orderBy === 'ASC' ? ArrowUpwardIcon : ArrowDownwardIcon}>
                      Last Updated
                    </TableSortLabel>

                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {audioCubeMerchantListData?.map((row) => (
                  <>
                    <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}  >
                      <TableCell>
                        <IconButton
                          data-testid='icon-button'
                          aria-label="expand row"
                          size="small"
                          onClick={() => handMerchantDetailsOpenClick(row?.key)}
                        >
                          {merchantDetailsOpen === row?.key ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                      </TableCell>
                      <TableCell sticky="left">
                        <StyledBadge
                          overlap="circular"
                          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                          variant="dot"
                          sx={{
                            '& .MuiBadge-badge': {
                              backgroundColor: row?.device_live_status?.toUpperCase() === 'ONLINE' ? 'green' : 'red',
                              color: row?.device_live_status?.toUpperCase() === 'ONLINE' ? 'green' : 'red'
                            },
                            '.MuiBadge-badge::after': {
                              animation: row?.device_live_status?.toUpperCase() === 'ONLINE' ? 'ripple 1.2s infinite ease-in-out' : 'none',
                            }
                          }}>
                          <Avatar alt={row?.name} />
                        </StyledBadge>
                      </TableCell>

                      <TableCell component="th" scope="row" onClick={() => handMerchantDetailsOpenClick(row?.key)}>
                        <RouterLink
                          to="/dashboard/soundboxdevicedetails"
                          state={{ merchantId: row?.key, organizationId: row?.organizationId }} >
                          {crossMarkString(row?.key)}
                        </RouterLink>
                      </TableCell>
                      <TableCell className="merchantTableListLabel" align="left" onClick={() => handMerchantDetailsOpenClick(row?.key)}>{showFieldValueWithCheck(row?.name)}</TableCell>
                      <TableCell className="merchantTableListLabel" align="left" onClick={() => handMerchantDetailsOpenClick(row?.key)}>{showFieldValueWithCheck(row?.phone)}</TableCell>
                      <TableCell className="merchantTableListLabel" align="left" onClick={() => handMerchantDetailsOpenClick(row?.key)}>{showFieldValueWithCheck(row?.merchantbranch?.zone)}</TableCell>
                      <TableCell className="merchantTableListLabel" align="left" onClick={() => handMerchantDetailsOpenClick(row?.key)}>{row?.activated ? "Assigned":"Not Assigned"}</TableCell>
                      <TableCell className="merchantTableListLabel" align="left" onClick={() => handMerchantDetailsOpenClick(row?.key)}>{isoDateFormatInDmyhs(row?.requested_date)} <br /> {row?.onboarding_channel}</TableCell>
                      <TableCell className="merchantTableListLabel" align="left" onClick={() => handMerchantDetailsOpenClick(row?.key)}>{showFieldValueWithCheck(isoDateFormatInDmyhs(row?.active_date))}</TableCell>
                      <TableCell className="merchantTableListLabel" align="left" onClick={() => handMerchantDetailsOpenClick(row?.key)}>{showFieldValueWithCheck(isoDateFToNow(row?.last_activity_date))}</TableCell>
                      <TableCell className="merchantTableListLabel"  >
                        <SoundBoxDeviceMoreMenu handleUser={row} handleClicks={(e) => handleUserMoreMenuClick(e, row)} />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell  style={{ paddingBottom: 0, paddingTop: 0, backgroundColor: 'rgba(195, 10, 10, .1)' }} colSpan={9}>
                        <Collapse in={merchantDetailsOpen === row?.key} timeout="auto" unmountOnExit>
                          <Grid data-testid='merchant-details-collapse' container sx={{ p: 5, width: '100%' }}  >
                            <Grid item sm={12} md={4} mb={1}>
                              <Typography className="merchantGridLableList" sx={{ fontWeight: 700 }}>Last Transaction</Typography>
                            </Grid>
                            <Grid item sm={12} md={8} mb={1}>
                              <Typography className="merchantGridLableList" >Rs. {row?.last_transaction_amt}</Typography>
                            </Grid>
                            <Grid item sm={12} md={4} mb={1}>
                              <Typography className="merchantGridLableList" sx={{ fontWeight: 700 }}>Rent Status</Typography>
                            </Grid>
                            <Grid item sm={12} md={8} mb={1}>
                              <Typography className="merchantGridLableList" >{row?.rent_to_be_collected}</Typography>
                            </Grid>
                            <Grid sm={12} md={4} mb={1}>
                              <Typography className="merchantGridLableList" sx={{ fontWeight: 700 }}>Device Id</Typography>
                            </Grid>
                            <Grid sm={12} md={8} mb={1}>
                              <Typography className="merchantGridLableList">{crossMarkString(row?.device_id)}</Typography>
                            </Grid>
                            <Grid sm={12} md={4} mb={1}>
                              <Typography className="merchantGridLableList" sx={{ fontWeight: 700 }}>Message Delivered/Received</Typography>
                            </Grid>
                            <Grid sm={12} md={8} mb={1}>
                              <Typography className="merchantGridLableList">{row?.total_message}/{row?.delivered}</Typography>
                            </Grid>
                          </Grid>
                        </Collapse>
                      </TableCell>

                    </TableRow>
                  </>

                ))}


              </TableBody>
            </Table>
          </TableContainer>
      }
      {audioCubeMerchantListDataLoading && <LinearProgress color="success" />}

      <TestSoundBoxPaymentModal
        soundboxDeviceListData={testSoundBoxModalMetas?.data}
        selectedMerchant={testSoundBoxModalMetas?.selectedMerchant}
        opneAssignedModal={testSoundBoxModalMetas?.open}
        handleClose={() =>
          setTestSoundBoxModalMetas({ ...testSoundBoxModalMetas, open: false, })}
      />

      <ActivateDeviceModal
        opneAssignedModal={activateModalMetas?.open}
        handleClose={() => setActivateModalMetas({ ...activateModalMetas, open: false })}
        merchantData={activateModalMetas?.selectedMerchant}
        type={activateModalMetas?.actionType}
      />
      
    </Box>
  );
}



MerchantListForSupport.propTypes = {
  audioCubeMerchantListData: PropTypes.array,
  createSortHandler: PropTypes.func,
  filterMetas: PropTypes.object,
  handleScroll: PropTypes.func,
  mref: PropTypes.object
}